export default {"src":"/_next/static/media/UPLAND.d4b1d755.svg","height":124,"width":460,"blurWidth":0,"blurHeight":0};